import React from 'react'
import cx from 'classnames'

import ParticipantMedia, {
  useIsParticipantVideoEnabled
} from './ParticipantMedia'

const RecordingScreenshare = () => {
  const { enabled: isVideoEnabled, media } =
    useIsParticipantVideoEnabled('SCREEN')

  return (
    <div className={cx('gp-Media-mainParticipantInfo', {})}>
      <div className='gp-Media-mainParticipantInfo-video'>
        {isVideoEnabled ? <ParticipantMedia media={media} /> : null}
      </div>
    </div>
  )
}
export default RecordingScreenshare
